import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as authReducer, REDUCER_NAME as AUTH_REDUCER_NAME } from './auth'
import { reducer as manageReducer, REDUCER_NAME as MANAGE_REDUCER_NAME } from './manage'

const reducer = combineReducers({
    [AUTH_REDUCER_NAME]: authReducer,
    [MANAGE_REDUCER_NAME]: manageReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/security/state/index.js